import { createSelector } from 'reselect';
import { RootState } from '../../../types';
import { EntityTypes } from '../../../constants/entities';
import { IEntityReducer } from 'core/reducers/entities';
import { IFolder } from 'types/domain/folder';
import { getEntities } from '../utils/getEntities';
import { IImage } from 'types/domain/image';
import { IText } from 'types/domain/text';
import { IPortraitVariant } from 'types/domain/base';
import { IModel } from 'types/domain/model';
import { IScene, ISceneConfig, ISceneDAO } from 'types/domain/scene';
import { IVideo } from 'types/domain/video';
import { IUploadFile } from 'core/slices/upload';
import { IKeyArray } from 'types/IKeyArray';

const entity = (state: RootState) => state.entity.present;
const uploads = (state: RootState) => state.core.upload.uploads;

export const selectFolders = createSelector(
  [entity, uploads],
  (entity: IEntityReducer, uploads: IKeyArray<IUploadFile>) => {
    return (
      Object.values(entity[EntityTypes.FOLDER])
        .filter(g => g.status > -1)
        //Filter out module folders. Will need to display current one
        //.filter(f => f.type !== FolderType.MODULE)

        .map((folder: IFolder) => parseFolderDAO(entity, folder.id, uploads))
    );
  },
);

export function parseFolderDAO(entity, id, uploadFiles?: IKeyArray<IUploadFile>) {
  const folder = entity[EntityTypes.FOLDER][id];

  if (!folder) return null;

  const module: any = Object.values(entity[EntityTypes.MODULE]).find((m: any) => m.folderId === folder.id);
  const text = module ? entity[EntityTypes.TEXT][module.textId] : null;
  const uploads: IUploadFile[] = uploadFiles
    ? Object.values(uploadFiles).filter((up: IUploadFile) => up.folderId === id) || []
    : [];

  return {
    ...folder,
    children: getEntities(entity, EntityTypes.FOLDER, 'parentId', folder.id),
    name: module ? text?.shortText || module.name : folder.name,
    uploads,
    scenes: getEntities(entity, EntityTypes.SCENE, 'folderId', folder.id).map((scene: IScene) => {
      return {
        ...scene,
        text: scene.textId ? (entity[EntityTypes.TEXT][scene.textId] as IText) : null,
        image: scene.imageId ? (entity[EntityTypes.IMAGE][scene.imageId] as IImage) : null,
        video: scene.videoId ? (entity[EntityTypes.VIDEO][scene.videoId] as IVideo) : null,
        model: scene.modelId ? (entity[EntityTypes.MODEL][scene.modelId] as IModel) : null,
        upload: uploads.find(up => up.sceneId === scene.id),
        sceneConfig: scene.sceneConfigId
          ? (entity[EntityTypes.SCENE_CONFIG][scene.sceneConfigId] as ISceneConfig)
          : null,
        portraitVariant: scene.portraitVarId
          ? (entity[EntityTypes.PORTRAIT_VARIANT][scene.portraitVarId] as IPortraitVariant)
          : null,
      } as ISceneDAO;
    }),
    modules: getEntities(entity, EntityTypes.MODULE, 'parentFolderId', folder.id),
  };
}
